import { combineReducers } from "redux";
import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { createReduxHistoryContext, routerReducer as originalRouterReducer } from "redux-first-history";
import { createBrowserHistory } from "history";

// Front
import LayoutReducer from "./layouts/reducer";
// Authentication
import LoginReducer from "./auth/login/reducer";
import PermissionReducer from "./auth/permission/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import SettingsReducer from "./auth/settings/reducer";
import MenuDataReducer from "./auth/menu/reducer";
import FeedReducer from "./feeds/reducer";
import CampaignReducer from "./campaigns/reducer";
import ModalReducer from "./modals/reducer";
import FolderReducer from "./folder/reducer";
import FontReducer from './fonts/reducer';
import PublishReducer from "./publish/reducer";
import ShowcaseReducer from "./showcase/reducer";
import UploadReducer from "./uploads/reducer";
import AnalyticsReducer from './analytics/reducer';

const {
	createReduxHistory,
	routerMiddleware,
	routerReducer
} = createReduxHistoryContext({ history: createBrowserHistory(), savePreviousLocations: 50 });

const customRouterReducer = (state, action) => {
	if (action.type === '@@router/UPDATE_PREVIOUS_LOCATIONS') {
		return {
      ...state,
      previousLocations: action.payload,
    };
	}

	return routerReducer(state, action);
}

const rootReducer = combineReducers({
	router: customRouterReducer,
	Layout: LayoutReducer,
	Login: LoginReducer,
	Permission: PermissionReducer,
	ForgetPassword: ForgetPasswordReducer,
	Settings: SettingsReducer,
	MenuData: MenuDataReducer,
	Feed: FeedReducer,
	Campaign: CampaignReducer,
	Modal: ModalReducer,
	Folder: FolderReducer,
	Font: FontReducer,
	Publish: PublishReducer,
	Showcase: ShowcaseReducer,
	Upload: UploadReducer,
	Analytics: AnalyticsReducer
});

// const historyUpdateMiddleware = (store) => (next) => (action) => {
//   if (action.type === '@@router/UPDATE_PREVIOUS_STATE') {
//     const { index, updates } = action.payload;
//     const state = store.getState();
//     const previousLocations = [...state.router.previousLocations];

//     if (previousLocations[index]) {
//       const updatedLocation = {
//         ...previousLocations[index],
//         location: {
//           ...previousLocations[index].location,
//           state: {
//             ...previousLocations[index].location.state,
//             ...updates,
//           },
//         },
//       };

//       previousLocations[index] = updatedLocation;

// 			const { pathname, search, state: locationState } = updatedLocation.location;
// 			// window.history.replaceState(locationState, "", pathname + search);
// 			console.log('history', history);
//     }

//     // Güncellenmiş state'i dispatch et
//     next({
//       type: "@@router/UPDATE_PREVIOUS_LOCATIONS",
//       payload: previousLocations,
//     });
//     return;
//   }

//   return next(action);
// };

export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }).concat(routerMiddleware),
	devTools: false
});

export const history = createReduxHistory(store);

export default rootReducer;